import { gql } from '@apollo/client';

export const CREATE_DISCRETE_RECEPTOR = gql`
    mutation CreateDiscreteReceptor($input: CreateDiscreteReceptor!) {
        facility {
            process {
                createDiscreteReceptor(input: $input) {
                    id
                }
            }
        }
    }
`;
